
namespace TabAurous.OMS {

    export class CashFlowOptions {
        items: AccountGroupRow[];
    }

    export class CashFlowPanel extends Serenity.TemplatedPanel<CashFlowOptions> {
        constructor(container: JQuery, opt: CashFlowOptions) {
            super(container, opt);


            //Grouping
            var data = this.options.items;
            var code = [""];
            var inflow = [0];
            var outflow = [0];
            outflow.pop();
            inflow.pop();
            var q1in = 0.0; var q2in = 0.0; var q3in = 0.0; var q4in = 0.0;
            var q1out = 0.0; var q2out = 0.0; var q3out = 0.0; var q4out = 0.0;
            for (var i = 0; i < data.length; i++) {
                if (data[i].Nature == "Income") {
                    q1in += data[i].Quarter1;
                    q2in += data[i].Quarter2;
                    q3in += data[i].Quarter3;
                    q4in += data[i].Quarter4;
                } else if (data[i].Nature == "Expenses") {
                    q1out += data[i].Quarter1;
                    q2out+= data[i].Quarter2;
                    q3out+= data[i].Quarter3;
                    q4out+= data[i].Quarter4;
                }

                
            }
            //var options = {
            //    chart: {
            //        height: 250,
            //        width: 430,
            //        type: 'bar',
            //        zoom: {
            //            enabled: false
            //        }
            //    },
            //    series: [
            //        {
            //            name: 'sales',
            //            data: grossamount
            //        }
            //    ],

            //    stroke: {
            //        curve: 'straight'
            //    },
            //    xaxis: {
            //        categories: code
            //    }
            //};

            var options = {
                series: [{
                    name: 'In-Flow',
                    data: [q1in, q2in, q3in, q4in]
                }, {
                        name: 'Out-Flow',
                        data: [q1out, q2out, q3out, q4out]
                }],
                chart: {
                    fontFamily: '"PT Sans", sans-serif',
                    type: 'bar',
                    height: 350,
                    width: 730
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
                },
                yaxis: {
                    title: {
                        text: '(thousands)'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return "" + val + " thousands"
                        }
                    }
                }
            };



            //var x = document.getElementById('TabAurous_Reports_ChartPanel13_chartContainer');
            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);

            chart.render();
        }

        getTemplate() {

            return `<div id="~_chartContainer"></div>`;
        }
    }

    @Serenity.Decorators.registerClass()
    export class CashFlowGrid extends Serenity.EntityGrid<AccountGroupRow, any> {
        protected getColumnsKey() { return 'OMS.CashFlow'; }
        protected getDialogType() { return AccountGroupDialog; }
        protected getIdProperty() { return AccountGroupRow.idProperty; }
        protected getInsertPermission() { return AccountGroupRow.insertPermission; }
        protected getLocalTextPrefix() { return AccountGroupRow.localTextPrefix; }
        protected getService() { return CashFlowService.baseUrl; }

        private chartContainer: JQuery;
        private chartPanel: CashFlowPanel;
        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Quarter1'),
                    new Slick.Aggregators.Sum('Quarter2'),
                    new Slick.Aggregators.Sum('Quarter3'),
                    new Slick.Aggregators.Sum('Quarter4')
                ]
            });
            this.view.setGrouping([{
                formatter: g => {
                    return "<span class='slick-group-title-header'>" +
                        g.value + " <span style='font-weight: bold;text-align: right;float:right;focusable:false;'>" +
                        g.totals.sum.Quarter4.toFixed(2) + "</span></span>" + "<span class='slick-cell l3 r3'>" +
                        " <span style='font-weight: bold;text-align: right;float:right;focusable:false;margin-left: 510px;'>" +
                        g.totals.sum.Quarter3.toFixed(2) + "</span></span>" + "<span class='slick-cell l2 r2'>" +
                        " <span style='font-weight: bold;text-align: right;float:right;focusable:false;'>" +
                        g.totals.sum.Quarter2.toFixed(2) + "</span></span>" + "<span class='slick-cell l1 r1'>" +
                        " <span style='font-weight: bold;text-align: right;float:right;focusable:false;'>" +
                        g.totals.sum.Quarter1.toFixed(2) + "</span></span>";
                },
                getter: 'Flow',
                displayTotalsRow: false,

            }])
            return grid;
        }

        onViewProcessData(response: Serenity.ListResponse<AccountGroupRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px 0' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            } 

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new CashFlowPanel(this.chartContainer, { items: response.Entities });

            var options = {
                chart: {
                    type: 'bar'
                },
                series: [
                    {
                        name: 'sales',
                        data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
                    }
                ],
                xaxis: {
                    categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
                }
            }

            var chart = new ApexCharts(document.querySelector(".chartContainer"), options);

            chart.render();


            return response;
        }
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push({
                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    Common.ReportHelper.execute({
                        reportKey: 'Finance.BalanceSheet',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date: this.view.params.Criteria
                        }
                    });
                }
            }
            );
            return buttons;
        }

    }
}